import React from "react";
import { Volume2 } from "lucide-react";

/**
 * Row used to display menu items whose bounding box wasn't reliably
 * detected — falls back to a card list under the scanned image.
 */
export default function MenuFallbackRow({ item, onSpeak }) {
  return (
    <div className="border-2 border-dashed border-ink rounded-sm bg-cream p-3 flex items-start gap-3">
      <div className="flex-1 min-w-0">
        <div className="font-fraunces text-base text-ink leading-snug">
          {item.translation}
        </div>
        <div className="font-bricolage italic text-[12px] text-muted2 leading-snug">
          {item.original}
        </div>
        {item.description_translation && (
          <div className="mt-1 font-bricolage text-[12px] text-ink leading-snug">
            {item.description_translation}
          </div>
        )}
      </div>
      {item.price && (
        <span className="shrink-0 font-mono text-[11px] bg-white border-2 border-ink rounded-sm px-2 py-0.5">
          {item.price}
        </span>
      )}
      {onSpeak && (
        <button
          onClick={() => onSpeak(item.original)}
          className="shrink-0 w-7 h-7 rounded-full bg-white border-2 border-ink flex items-center justify-center hover:bg-sand transition-colors"
          aria-label="Speak"
        >
          <Volume2 size={11} strokeWidth={2.5} />
        </button>
      )}
    </div>
  );
}
